<div class="tw-flex tw-flex-col tw-h-full tw-mb-4">
    <div class="tw-flex tw-items-center tw-gap-0 tw-mb-1 xl:tw-mb-0">
        <div class="tw-flex tw-items-center tw-justify-between tw-flex-grow">
            <h5 id="leaderboard" class="tw-text-sm tw-text-black tw-font-bold">
                {{ name }}
            </h5>
            <div *ngIf="showFullLeaderboardBtn" class="tw-text-right">
                <a
                    class="tw-text-info tw-text-sm tw-no-underline hover:tw-font-bold"
                    [routerLink]="['/dashboard', { slide: 'leaderboard', range: range.value }]"
                    translate
                    linkDataTest="fullLeaderboardLink"
                    >v3-button-full-leaderboard</a
                >
            </div>
        </div>
    </div>

    <!-- Loader - block -->
    <div *ngIf="loading && !leaderboard">
        <app-loader loaderColor="default" loaderSize="s"></app-loader>
    </div>

    <div *ngIf="leaderboard" class="tw-flex tw-items-center tw-gap-1">
        <div role="region" aria-live="polite" class="tw-w-full">
            <div
                role="list"
                class="list tw-relative tw-flex tw-items-center tw-gap-1 tw-flex-wrap xl:tw-flex-nowrap"
                [class.wrapped]="isVeryLargeFontSize$ | async"
            >
                <div
                    role="listitem"
                    *ngFor="let item of leaderboard; let last = last"
                    class="item tw-flex tw-items-center tw-border-solid tw-border b-{{ getTrendColor(item.trend) }}"
                >
                    <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
                        <div class="tw-flex tw-items-center">
                            <div
                                class="tw-text-center tw-relative tw-inline-flex tw-justify-center tw-items-center tw-rounded-full tw-border tw-border-solid tw-box-content tw-mr-3 tw-font-bold"
                                [ngClass]="['b-' + getTrendColor(item.trend), item.rank > 99 ? 'tw-size-8.5' : 'tw-size-6.5']"
                            >
                                <span [ngClass]="['tw-text-' + getTrendColor(item.trend), item.rank > 99 ? 'tw-font-xs' : 'tw-font-sm']">{{ item.rank }}</span>
                            </div>
                            <div class="name-wrapper tw-px-0 tw-text-black">
                                <div class="tw-text-sm tw-font-bold tw-leading-tight text-oneline">{{ item.firstname }}</div>
                                <div class="tw-text-sm tw-font-bold tw-leading-tight text-oneline">{{ item.surname }}</div>
                            </div>
                        </div>
                        <div class="tw-flex tw-items-center">
                            <div>
                                <span class="tw-text-xs tw-text-black tw-text-nowrap">{{
                                    'v3-global-number-pts' | translate: { points: item.points | pts }
                                }}</span>
                            </div>
                            <div aria-hidden="true" class="tw-ml-3">
                                <div [ngSwitch]="item.trend">
                                    <div *ngSwitchCase="'success'">
                                        <app-icon name="arrow-up" class="tw-fill-success tw-w-4 tw-h-4"></app-icon>
                                    </div>
                                    <div *ngSwitchCase="'muted'">
                                        <div class="tw-size-4 tw-rounded-full tw-bg-black-10"></div>
                                    </div>
                                    <div *ngSwitchCase="'danger'">
                                        <app-icon name="arrow-down" class="tw-fill-danger tw-w-4 tw-h-4"></app-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Loader - overlay -->
                <app-loader *ngIf="loading && leaderboard" loaderType="cover" loaderSize="s" overlayColor="white"></app-loader>
            </div>
        </div>
        <div *ngIf="!loading" class="range-dropdown tw-leading-none inline">
            <form [formGroup]="form">
                <app-leaderboard-dropdown controlName="range" />
            </form>
        </div>
    </div>
</div>
